import React, { useMemo, useState, useEffect } from 'react';
import MapView from '../components/Map/MapView';
import { moderationAPI } from '../services/api';
import Loading from '../components/Common/Loading';

// Extrahiert [lat, lng] aus einer Aktivitaet (oder null, falls keine Koordinaten)
const getPosition = (activity) => {
  if (activity.latitude && activity.longitude) {
    return [activity.latitude, activity.longitude];
  }
  if (activity.location && activity.location.coordinates) {
    return [activity.location.coordinates[1], activity.location.coordinates[0]];
  }
  if (typeof activity.location === 'string') {
    const match = activity.location.match(/POINT\(([\d.]+)\s+([\d.]+)\)/);
    if (match) return [parseFloat(match[2]), parseFloat(match[1])];
  }
  return null;
};

const ActivityMap = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        // Die Karte braucht alle Aktivitaeten, aber nur Koordinaten und Beschriftung
        const response = await moderationAPI.getAll({
          fields: 'id,name,address,location_name,latitude,longitude',
        });
        setActivities(response.data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Aktivitaeten zu Orten gruppieren (Schluessel: gerundete Koordinaten)
  const locations = useMemo(() => {
    const byPosition = new Map();
    activities.forEach((activity) => {
      const position = getPosition(activity);
      if (!position) return;
      const key = `${position[0].toFixed(5)},${position[1].toFixed(5)}`;
      if (!byPosition.has(key)) {
        byPosition.set(key, {
          key,
          position,
          locationName: activity.location_name || '',
          address: activity.address || '',
          activities: [],
        });
      }
      const entry = byPosition.get(key);
      // Fehlende Ortsbezeichnung ggf. aus einer weiteren Aktivitaet ergaenzen
      if (!entry.locationName && activity.location_name) entry.locationName = activity.location_name;
      if (!entry.address && activity.address) entry.address = activity.address;
      entry.activities.push(activity);
    });
    return Array.from(byPosition.values());
  }, [activities]);

  if (loading) return <Loading />;
  if (error) return <div>Fehler: {error}</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700 }}>Orte der Aktivitäten</h1>
      <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>
        Verteilung der Aktivitäten nach Orten ({locations.length} {locations.length === 1 ? 'Ort' : 'Orte'},{' '}
        {activities.length} {activities.length === 1 ? 'Aktivität' : 'Aktivitäten'})
      </p>
      <div style={{ height: '75vh', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
        <MapView
          locations={locations}
          center={[47.4995, 8.7247]}
          zoom={12}
        />
      </div>
    </div>
  );
};

export default ActivityMap;
